import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import Button from "@mui/material/Button";
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import I18N from "oc-modules/oc-I18N";

export default function AreYouSureClosure(options) {
  let interval = {};

  const onSuccess = options?.onSuccess ? options.onSuccess : () => {APP.arrangement.dialog = undefined};
  const onDecline = options?.onDecline ? options.onDecline : () => {APP.arrangement.dialog = undefined};

  return function AreYouSure() {
    return <div>
        <DialogTitle id="alert-dialog-title">
            {I18N("are you sure?")}
        </DialogTitle>
        <DialogActions>
            <Button onClick={onDecline} autoFocus>{I18N("decline")}</Button>
            <Button onClick={onSuccess}>{I18N("success")}</Button>
        </DialogActions>
    </div>;
  };
}
